import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import jsPDF from 'jspdf';
import 'jspdf-autotable';

const ReservationSuccess = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const reservation = location.state?.reservation;

    if (!reservation) {
        return <p>No se encontraron detalles de la reserva.</p>;
    }

    // --- FUNCIÓN DE PDF REDISEÑADA ---
    const handleDownloadPDF = () => {
        const doc = new jsPDF();
        const pageWidth = doc.internal.pageSize.getWidth();
        
        // Encabezado con Logo y Nombre del Hostal
        doc.addImage('/images/logo.png', 'PNG', 15, 10, 30, 30); // Asegúrate de tener tu logo en /public/images/logo.png
        doc.setFont("helvetica", "bold");
        doc.setFontSize(24);
        doc.setTextColor(40, 40, 40);
        doc.text("Hostal Jallalla", pageWidth - 20, 25, { align: "right" });
        doc.setFontSize(10);
        doc.setTextColor(150, 150, 150);
        doc.text("Comprobante de Reserva", pageWidth - 20, 32, { align: "right" });

        // Línea divisoria
        doc.setDrawColor(230, 230, 230);
        doc.line(15, 45, pageWidth - 15, 45);

        // Título de la Reserva
        doc.setFont("helvetica", "bold");
        doc.setFontSize(18);
        doc.setTextColor(0, 123, 255); // Un color azul
        doc.text("¡Tu reserva está confirmada!", 15, 60);

        // Información del Cliente
        doc.setFontSize(12);
        doc.setTextColor(40, 40, 40);
        doc.setFont("helvetica", "normal");
        doc.text(`Cliente: ${reservation.clientName}`, 15, 75);
        if (reservation.clientName2) {
            doc.text(`Acompañante: ${reservation.clientName2}`, 15, 82);
        }
        doc.text(`RUT o Pasaporte: ${reservation.rutOrPassport}`, 15, 89);
        doc.text(`Teléfono: ${reservation.phone || 'No especificado'}`, 15, 96);
        
        // Tabla con detalles de la reserva
        const tableColumn = ["Detalle", "Información"];
        const tableRows = [
            ["N° de Habitación", reservation.roomId],
            ["Huéspedes", reservation.numberOfGuests],
            ["Fecha de Ingreso (Check-in)", new Date(reservation.checkIn + 'T00:00:00').toLocaleDateString('es-ES')],
            ["Fecha de Salida (Check-out)", new Date(reservation.checkOut + 'T00:00:00').toLocaleDateString('es-ES')],
            ["Total de Noches", reservation.nights],
            ["Costo Total", `${reservation.totalCost.toLocaleString('es-CL')} CLP`],
            // Fila destacada para el estado del pago
            [{ content: "Estado del Pago", styles: { fontStyle: 'bold' } }, { content: reservation.paymentStatus === 'pagado' ? 'PAGADO' : 'PENDIENTE DE PAGO EN EL HOSTAL', styles: { fontStyle: 'bold', textColor: reservation.paymentStatus === 'pagado' ? [0, 128, 0] : [255, 165, 0] } }]
        ];

        doc.autoTable({
            startY: 110,
            head: [tableColumn],
            body: tableRows,
            theme: 'striped',
            headStyles: { fillColor: [0, 123, 255] }, // Azul para el encabezado
            styles: { fontSize: 11, cellPadding: 3 },
            columnStyles: { 1: { halign: 'right' } }
        });

        // Pie de página
        const finalY = doc.autoTable.previous.finalY || 180;
        doc.setFontSize(10);
        doc.setTextColor(150, 150, 150);
        doc.text("¡Gracias por elegirnos! Te esperamos en Hostal Jallalla.", pageWidth / 2, finalY + 20, { align: "center" });
        doc.text("Vivar #1478, Calama", pageWidth / 2, finalY + 25, { align: "center" });

        doc.save(`Reserva_HostalJallalla_${reservation.clientName.replace(/\s/g, '_')}.pdf`);
    };

    return (
        <div style={{ textAlign: 'center', padding: '50px' }}>
            <h1 style={{ color: 'green' }}>¡Felicidades!</h1>
            <p>Tu reserva ha sido realizada exitosamente.</p>
            <img
                src="/images/success.jpg"
                alt="Reserva Exitosa"
                style={{
                    width: '300px',
                    margin: '20px 0',
                    borderRadius: '15px'
                }}
            />
            <p>
                <strong>Detalles de la Reserva:</strong>
            </p>
            <ul style={{ listStyle: 'none', padding: 0, textAlign: 'left', display: 'inline-block', border: '1px solid #eee', padding: '20px', borderRadius: '8px' }}>
                <li><strong>Habitación:</strong> {reservation.roomId}</li>
                <li><strong>Cliente:</strong> {reservation.clientName}</li>
                <li><strong>Huéspedes:</strong> {reservation.numberOfGuests}</li>
                <li><strong>Check-In:</strong> {new Date(reservation.checkIn + 'T00:00:00').toLocaleDateString('es-ES')}</li>
                <li><strong>Check-Out:</strong> {new Date(reservation.checkOut + 'T00:00:00').toLocaleDateString('es-ES')}</li>
                <li><strong>Noches:</strong> {reservation.nights}</li>
                <li><strong>Total:</strong> {reservation.totalCost.toLocaleString('es-CL')} CLP</li>
                {/* --- LÍNEA AÑADIDA Y MEJORADA --- */}
                <li style={{ marginTop: '10px', paddingTop: '10px', borderTop: '1px solid #eee' }}>
                    <strong>Estado del Pago: </strong>
                    <span style={{ color: reservation.paymentStatus === 'pagado' ? 'green' : '#E67E22', fontWeight: 'bold' }}>
                        {reservation.paymentStatus === 'pagado' ? 'Pagado' : 'Pendiente'}
                    </span>
                </li>
            </ul>
            <div style={{ marginTop: '30px' }}>
                <button
                    onClick={() => navigate('/')}
                    style={{
                        marginRight: '10px',
                        padding: '12px 25px',
                        backgroundColor: '#007bff',
                        color: '#fff',
                        border: 'none',
                        borderRadius: '5px',
                        cursor: 'pointer',
                        fontSize: '16px'
                    }}
                >
                    Volver a Inicio
                </button>
                <button
                    onClick={handleDownloadPDF}
                    style={{
                        padding: '12px 25px',
                        backgroundColor: '#28a745',
                        color: '#fff',
                        border: 'none',
                        borderRadius: '5px',
                        cursor: 'pointer',
                        fontSize: '16px'
                    }}
                >
                    Descargar Comprobante PDF
                </button>
            </div>
        </div>
    );
};

export default ReservationSuccess;